import request from '@/services/utils/request'

// 登录方法
export function login(username, password, captchaVerification) {
    const data = {
        username,
        password,
        captchaVerification,
        clientId: 'app'
    }
    return request({
        url: '/system/auth/login',
        headers: {
            isToken: false
        },
        method: 'POST',
        data: data
    })
}

// 新-获取用户信息
export function getUserInfo(options = {}) {
    return request({
        ...options,
        url: '/system/user/profile/get',
        method: 'GET'
    })
}

// 更新用户信息
export function updateUserInfo(data) {
    return request({
        url: '/system/user/profile/update',
        method: 'PUT',
        data: data
    })
}

// 退出方法
export function logout() {
    return request({
        authBootstrap: true,
        url: '/system/auth/logout',
        method: 'POST'
    })
}

// 社交授权的跳转
export function socialAuthRedirect(type, redirectUri) {
    return request({
        url: '/system/auth/social-auth-redirect?type=' + type + '&redirectUri=' + redirectUri,
        method: 'GET'
    })
}

// 社交快捷登录，使用 code 授权码
export function socialLogin(type, code, state) {
    return request({
        url: '/system/auth/social-login',
        method: 'POST',
        data: { type, code, state }
    })
}

// 获取用户权限信息
export function getInfo(options = {}) {
    return request({
        ...options,
        url: '/system/auth/get-permission-info',
        method: 'GET',
        params: { platform: 'h5' }
    })
}

// 社交绑定，使用 code 授权码
export const socialBind = (type, code, state) => {
    return request({
        url: '/system/social-user/bind',
        method: 'POST',
        data: { type, code, state }
    })
}

// 取消社交绑定
export const socialUnbind = (type, openid) => {
    return request({
        url: '/system/social-user/unbind',
        method: 'DELETE',
        data: { type, openid }
    })
}
